import { ProfileEntity } from "../../api/Identity/Entity";
import { RoleEntity } from "../../api/Role/Entity/RoleEntity";
import { RootState } from "../store";

export const selectProfile = (state: RootState): ProfileEntity =>
  state.profile.userProfile;

export const selectProfilePictureBase64 = (state: RootState): string =>
  state.profile.userPictureUrl;

export const selectProfileRole = (state: RootState): RoleEntity =>
  state.profile.userProfileRole;
